import axios from "axios";

export const state = {
    checkoffcarts: [],
};

export const getters = {
    checkoffcarts: state => state.checkoffcarts,
};

export const mutations = {
    setCheckoffCarts(state, newValue) {
        state.checkoffcarts = newValue
    },
};

export const actions = {
    async fetchCheckoffCarts({ commit }) {
        await axios.get('/checkoff-list-cart').then(res => {
            commit('setCheckoffCarts', res.data.checkoffcarts);
        })
    },
};
